var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [
        _vm._v(_vm._s(_vm.printDate(_vm.stats?.updated_at, "DD.MM.YYYY"))),
      ]),
      _vm._v(" "),
      +(_vm.stats?.extra_data?.in_stores || 0) === 0
        ? [
            _c("p", [_vm._v("нет в аптеках")]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.printDate(
                      _vm.stats?.extra_data?.last_date,
                      "DD.MM.YYYY"
                    )
                  )
                ),
              ]),
              _vm._v("\n      - "),
              _c("span", [
                _vm._v(_vm._s(_vm.stats?.extra_data?.last_price || 0) + "р"),
              ]),
            ]),
          ]
        : [
            _c("p", [
              _vm._v("мин. "),
              _c("strong", [
                _vm._v(_vm._s(_vm.stats?.extra_data?.min_price || 0)),
              ]),
              _vm._v(" Ø\n      "),
              _c("strong", [
                _vm._v(_vm._s(_vm.stats?.extra_data?.avarage_price || 0)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("аптек: "),
              _c("strong", [
                _vm._v(_vm._s(_vm.stats?.extra_data?.in_stores || 0)),
              ]),
            ]),
          ],
      _vm._v(" "),
      _c("p"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }